<mat-form-field class="example-full-width">
  <mat-select [(ngModel)]="conditionId" [disabled]="!editMode">
    @for (condition of conditions; track condition) {
      <mat-option [value]="condition.id" (onSelectionChange)="onConditionChange(condition, $event, undefined)">
        {{ condition.name }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>

@if (selected) {
  <app-nested-panel-form-field
    [fields]="fields"
    [canAdd]="false"
    [editMode]="editMode"
    [fieldConfig]="selectedFieldConfig"
    [(formGroup)]="formGroup"
    [(data)]="conditionData"></app-nested-panel-form-field>
}
